var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximizeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FC5726",
    strokeWidth: 2,
    fill: "#FFF",
    x: 1,
    y: 1,
    width: 38,
    height: 37,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 15.012V6.237l-.001-.021c-.001-.034-.002-.067-.005-.101l-.008-.057-.01-.063-.015-.061a.924.924 0 0 0-.015-.056c-.005-.02-.013-.039-.02-.057l-.02-.058-.024-.05a1.25 1.25 0 0 0-.028-.06l-.028-.045c-.011-.02-.022-.04-.035-.058-.01-.016-.023-.032-.035-.048l-.037-.05a1.49 1.49 0 0 0-.067-.073l-.014-.017c-.005-.005-.012-.009-.017-.015a1.49 1.49 0 0 0-.074-.066l-.05-.038c-.015-.011-.03-.023-.047-.034-.019-.013-.038-.024-.058-.035l-.046-.028a1.25 1.25 0 0 0-.058-.028c-.018-.008-.034-.017-.051-.023l-.058-.022-.057-.02a.924.924 0 0 0-.056-.014c-.02-.005-.04-.011-.062-.015l-.062-.01-.057-.008a1.367 1.367 0 0 0-.101-.005L33.763 5h-8.776a1.237 1.237 0 0 0 0 2.474h5.79l-9.618 9.618a1.236 1.236 0 1 0 1.75 1.748l9.617-9.617v5.79a1.234 1.234 0 0 0 1.237 1.236c.683 0 1.237-.554 1.237-1.237M5 24.988v8.775l.001.021c0 .034.002.067.005.101l.008.057.01.063.015.061a.924.924 0 0 0 .015.056c.005.02.013.039.02.057l.02.058c.007.017.016.033.024.05a1.25 1.25 0 0 0 .056.105c.01.02.022.04.035.058.01.016.023.032.034.048l.038.05c.02.025.043.05.066.073l.015.017c.005.005.012.009.017.015.024.023.048.045.074.066l.05.038c.015.011.03.023.047.034.018.013.038.024.058.035l.046.028.058.028c.018.008.034.017.051.023l.058.022.057.02.056.014c.02.005.04.011.061.015l.063.01.057.008c.034.003.067.004.1.005l.022.001h8.775a1.237 1.237 0 0 0 0-2.474h-5.79l9.618-9.618a1.236 1.236 0 1 0-1.748-1.748l-9.619 9.617v-5.79a1.234 1.234 0 0 0-1.236-1.236c-.683 0-1.237.554-1.237 1.237",
    fill: "#FC5726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeButton);
export default __webpack_public_path__ + "static/media/maximize_button.2354f93fedfe4525de0fcafe40d0760e.svg";
export { ForwardRef as ReactComponent };